export const PERSON_TYPE_OWNER = 'OWNER';

export const PERSON_TYPE_EMPLOYEE = 'EMPLOYEE';

export const PERSON_TYPE_INSURANCE = 'INSURANCE';

export const PERSON_TYPE_SELECT_OPTIONS = [
  {
    label: 'Owner',
    value: PERSON_TYPE_OWNER,
  },
  {
    label: 'Employee',
    value: PERSON_TYPE_EMPLOYEE,
  },
];
